"use client";

import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";
import { useSearchParamsManager } from "@/hooks/useSearchParams";
import { Cancel01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { cn } from "@/lib/utils";

interface InstantToggleProps {
  instant: boolean;
  className?: string;
}

export function InstantToggle({ instant, className }: InstantToggleProps) {
  const { updateParam } = useSearchParamsManager();

  const handleInstantChange = (checked: boolean) => {
    updateParam("isInstantBookable", checked ? "true" : "false");
  };

  return (
    <Button
      onClick={() => handleInstantChange(!instant)}
      variant="pill"
      className={cn(
        "gap-0 transition-colors duration-500",
        instant && "border-primary text-primary",
        className
      )}
    >
      <Typography variant="captionRegular">آنی و قطعی</Typography>
      <HugeiconsIcon
        icon={Cancel01Icon}
        className={`size-4 overflow-hidden transition-all duration-500 ${
          instant ? "max-w-5 mr-2" : "max-w-0"
        }`}
      />
    </Button>
  );
}
